import { render, staticRenderFns } from "./AdminChangePasswordPage.vue?vue&type=template&id=5f36430a&"
import script from "./AdminChangePasswordPage.vue?vue&type=script&lang=js&"
export * from "./AdminChangePasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports